KROWN.themeName = 'Split';
KROWN.themeVersion = '4.3.0';

const executeOnceOnDomContentLoaded = ()=>{

  // tab navigation

  let activeElement = document.activeElement;
  document.addEventListener('keyup', e=>{
    if ( e.keyCode == window.KEYCODES.TAB ) {
      if ( activeElement.classList.contains('focus') && e.target != activeElement ) {
        activeElement.classList.remove('focus');
      }
      if ( e.target.classList.contains('product-variant__input') ||
      	e.target.classList.contains('button') ||
      	e.target.classList.contains('product-item') ||
      	e.target.classList.contains('spr-summary-actions-newreview') ||
      	e.target.classList.contains('site-box-content-to-focus')
      ) {
        e.target.classList.add('focus');
      } 
      activeElement = document.activeElement;
    }
  });

  // newsletter has jump

  if ( window.location.pathname.includes('/challenge') ) {
    setTimeout(()=>{
      window.scroll({
        top: 0, 
        behavior: 'auto'
      });
    }, 300);
  }

  // fix image link borders

  document.querySelectorAll('.rte a img').forEach(elm=>{
    elm.parentNode.style.border = 'none';
  });

  // Filter handle
  
  if ( document.getElementById('site-filter-handle') ) {
    document.getElementById('site-filter-handle').addEventListener('click', e=>{
      e.preventDefault();
      document.getElementById('site-filters').show();
      document.getElementById('site-filter-handle').setAttribute('aria-expanded', 'true');
    });
  }

  // fix quick add to cart

  setTimeout(()=>{
    if ( document.querySelector('modal-box quick-view-product') ) {
      document.querySelector('modal-box quick-view-product').init();
    }
    if ( document.querySelector('modal-box quick-add-to-cart') ) {
      document.querySelector('modal-box quick-add-to-cart').init();
      document.querySelector('modal-box product-form').init();
    }
  }, 3050);

  // show newsletter popup confimation

  if ( document.location.search == '?customer_posted=true' && document.location.hash == '#newsletter-popup' && document.getElementById('modal-newsletter') ) {
    const newsletterPopup = document.getElementById('modal-newsletter');
    newsletterPopup.show();
    localStorage.setItem(newsletterPopup._modalKey, JSON.stringify({
      'shown': (new Date().getTime()),
      'content': newsletterPopup._modalText
    }));	
    setTimeout(()=>{
      newsletterPopup.querySelectorAll('[data-js-close]').forEach(elm=>elm.addEventListener('click',()=>{newsletterPopup.hide(true)}));
    }, 100);
    clearTimeout(newsletterPopup._modalTimeout);
  }

  // custom cart listener
  
  if ( document.querySelector('cart-form') ) {
    document.querySelector('cart-form').addEventListener('cart-updated', ()=>{
      if ( document.body.classList.contains('template-cart') ) {

        if ( document.querySelector('#AjaxCartForm .subtitle') ) {
          document.querySelector('#section-cart .box__heading .subtitle').innerHTML = document.querySelector('#AjaxCartForm .subtitle').innerHTML;
        }
        if ( document.getElementById('AjaxCartSubtotal').querySelector('[data-cart-empty]') ) {
          document.querySelector('#section-cart .box__heading .subtitle').innerHTML = "";
          if ( ! document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content') ) {
            document.getElementById('AjaxCartSubtotal').append(document.getElementById('section-cart').querySelector('template').content.cloneNode(true))
          } else {
            document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content').style.display = 'block';
          }
        } else if ( document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content') ) {
          document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content').style.display = 'none';
        }

      }

      if ( document.querySelector('cart-recommendations') && parseInt(document.querySelector('[data-cart-count]').textContent ) == 0 ) {
        document.querySelector('cart-recommendations').innerHTML = '';
      }

    });
  }

  // recommended products listener

  if ( document.querySelector('#main-product-recommendations') ) {
    document.querySelector('#main-product-recommendations').addEventListener('product-recommendations-loaded', ()=>{
      eval(document.querySelector('#main-product-recommendations .js-fix-height').textContent);
    });
  }

}

if ( document.readyState !== 'loading' ) {
  executeOnceOnDomContentLoaded();
} else {
  document.addEventListener('DOMContentLoaded', executeOnceOnDomContentLoaded);
}

if ( typeof SiteFilterHandle !== 'function' ) {

	class SiteFilterHandle extends HTMLElement {
		constructor(){
			super();
			const sidebar = document.getElementById(this.getAttribute('aria-controls'));
			this.addEventListener('click', e=>{
				if ( ! this.classList.contains('disable-sidebar') ) {
					e.preventDefault();
					this.setAttribute('aria-expanded', 'true');
					sidebar.show();
				}
			})
			this.addEventListener('keyup', e=>{
				if ( e.keyCode == window.KEYCODES.RETURN ) {
					this.setAttribute('aria-expanded', 'true');
					sidebar.show();
					sidebar.querySelector('.site-close-handle').focus();
				}
			})
		}
  }

  if ( typeof customElements.get('site-filter-handle') == 'undefined' ) {
    customElements.define('site-filter-handle', SiteFilterHandle);
  }

}

// Register Your Travel Case
// $('#ContactFormNumber').keypress(function(e){
//   var $limit = parseInt($(this).attr('minlength'));
//   if($(this).val().length < $limit){
//       $(this).parents('#contact_form_register-your-travel-case-form').find('.btn').attr('type','button');
//   }else{
//     $(this).parents('#contact_form_register-your-travel-case-form').find('.btn').attr('type','submit');
//   }
// });

// Function to handle keypress event on the ContactFormNumber input
// document.getElementById('ContactFormNumber').addEventListener('keypress', function(e) {
//   var $limit = parseInt(this.getAttribute('minlength'), 10);
//   if (this.value.length < $limit) {
//     this.closest('#contact_form_register-your-travel-case-form').querySelector('.btn').setAttribute('type', 'button');
//   } else {
//     this.closest('#contact_form_register-your-travel-case-form').querySelector('.btn').setAttribute('type', 'submit');
//   }
// });

document.addEventListener('DOMContentLoaded', function() {
  // Check if the ContactFormNumber element exists
  var contactFormNumber = document.getElementById('ContactFormNumber');
  if (contactFormNumber) {
    // Function to handle keypress event on the ContactFormNumber input
    contactFormNumber.addEventListener('keypress', function(e) {
      var $limit = parseInt(this.getAttribute('minlength'), 10);
      var btn = this.closest('#contact_form_register-your-travel-case-form')?.querySelector('.btn');
      if (btn) {
        if (this.value.length < $limit) {
          btn.setAttribute('type', 'button');
        } else {
          btn.setAttribute('type', 'submit');
        }
      }
    });
  }

  // Check if the submit button exists
  var submitButton = document.querySelector('#contact_form_register-your-travel-case-form .btn');
  if (submitButton) {
    // Function to handle click event on the submit button
    submitButton.addEventListener('click', function(e) {
      e.preventDefault(); // Prevent default form submission

      var $this = this;
      // $this.disabled = true;

      var inputFields = document.querySelectorAll('.register-your-travel-case-form .input-full');
      var isAnyFieldEmpty = false;
      var isEmailInvalid = false;
      
      var errorMessage = document.querySelector('.error-message');
      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      // Check if any input field is empty
      inputFields.forEach(function(input) {

        if (input.type === 'email') {
          if (!emailRegex.test(input.value.trim())) {
            isEmailInvalid = true;
            errorMessage.style.display = 'block';
            input.classList.add('input-error'); 
            errorMessage.textContent = 'Please enter a valid email address.';
          } else {
            // errorMessage.style.display = 'none';
            input.classList.remove('input-error');
          }
        }
        
        if (input.value.trim() === '') {
          isAnyFieldEmpty = true;
          errorMessage.style.display = 'block';
          input.classList.add('input-error');
          errorMessage.textContent = 'All fields are required.';
        }else {
          if(!isEmailInvalid) {
            errorMessage.style.display = 'none';  
            input.classList.remove('input-error');
          }
        }

        input.addEventListener('input', function() {
           if (input.value.trim() !== '') {
            input.classList.remove('input-error');
           }else{
             input.classList.add('input-error');
           }
        });
      });

      
      console.log(isEmailInvalid,'isEmailInvalid')
      // If no field is empty, proceed with form submission
      if (!isAnyFieldEmpty && !isEmailInvalid) {

        var loadingGif = document.querySelector(".loading_form_gif");
        var submitFormBtn = document.querySelector(".form-submit-btn #submit-form");
  
        if (loadingGif) {
          loadingGif.style.display = "inline-block";
        }
        if (submitFormBtn) {
          submitFormBtn.style.display = "none";
        }
        
        var $form = document.querySelector('#contact_form_register-your-travel-case-form');
        if ($form) {
          var url = 'https://script.google.com/macros/s/AKfycbxG_uy1n7Fl0PqKH68qAfSe8nHTGogVwb3FQMHk-LsMhdayYM5Ton2c-nhcbH7NUC49/exec';

          var xhr = new XMLHttpRequest();
          xhr.open("GET", url + '?' + new URLSearchParams(new FormData($form)).toString(), true);
          xhr.responseType = 'json';

          xhr.onload = function() {
            if (xhr.status >= 200 && xhr.status < 300) {
              $form.submit();
            } else {
              $this.disabled = false;
            }
            if (loadingGif) {
              loadingGif.style.display = "none";
            }
            if (submitFormBtn) {
              submitFormBtn.style.display = "inline-block";
            }
          };

          xhr.onerror = function() {
            $this.disabled = false;
          };

          xhr.send();
        }
      } else {
        $this.disabled = false;
      }
    });
  }

  fetch('/browsing_context_suggestions.json')
  .then(response => response.json())
  .then(data => {
    const countryCode = data.detected_values.country.handle;
    var promoElement = document.querySelector('.sticky-promo');
    var promoText = promoElement.textContent;
    var announceElement = document.querySelector('.announcement');
    var announcementText = announceElement?.textContent;

    if(countryCode == 'SG') {
      announcementText = announcementText.replace("Free US", "Free Singapore");
    }
    if(countryCode == 'AE') {
        announcementText = announcementText.replace("Free US", "Free UAE");
    }

    if (promoElement && promoText.trim() !== '' && announceElement && announcementText.trim() !== '') {
      document.querySelector('.sticky-promo').textContent = promoText + ' | ' + announcementText;
      var bgColor = '#cccccc';
      var txtColor = '#212121';
      var announcementBarElement = document.querySelector('announcement-bar');
      if(announcementBarElement) {
        var barStyle = window.getComputedStyle(announcementBarElement);
        bgColor = barStyle.backgroundColor;
        var annouceBar = document.querySelector('.announcement-bar');
        annouceBarStyle = window.getComputedStyle(annouceBar);
        txtColor = annouceBarStyle.color;
      }
      promoElement.style.color = txtColor;
      promoElement.style.backgroundColor = bgColor;
      promoElement.style.fontWeight = 'bold';
      announcementBarElement.remove();
    }
    else {
      console.log('here');
      document.querySelector('.announcement').textContent = announcementText;
    }
  })
  .catch(error => {
    console.error('Error fetching country data:', error);
  });
 
  
  let target = document.querySelector('.footer-content.rte');

  let pElement = document.createElement('p');
  pElement.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0067/2759/8135/files/map_pin.png" alt="" style="max-width: 18px;vertical-align: text-bottom;">  3515 Airway Dr, Reno, NV 89511`;
  target.removeChild(target.lastElementChild);
  target.appendChild(pElement);  

  //Adding 5* to homepage
  const elements = document.querySelectorAll('.cite.text-size--smaller');
  const starIcon = '<i class="stamped-fa stamped-fa-star"></i>';
  
  elements.forEach(element => {
    const stars = starIcon.repeat(5);
    element.innerHTML = stars + '&nbsp;'.repeat(2) +element.innerHTML;
  });

  //
  document.querySelectorAll('.site-box-content.reduce-top-margin-if-first > div > div')
  .forEach(el => {
    if (el.textContent.trim() === '' && el.children.length === 0) {
      const parent = el.closest('.site-box-content.reduce-top-margin-if-first');
      if (parent) {
        parent.style.display = 'none';
      }
    }
  });
  
});



var checkStamped = setInterval(function () {
  var el = document.querySelector('#stamped-main-widget .stamped-container');
  if (!el) return;

  const dataEl = document.getElementById('products_material_details');
  if (!dataEl) return;

  const data = JSON.parse(dataEl.textContent);
  el.querySelectorAll(".stamped-review").forEach(review => {
    const productId = review.dataset.productId;
    // Find matching object by key
    const found = data.find(item => {
      return Object.keys(item)[0] === productId;
    });
    const material = found
      ? Object.values(found)[0]
      : "";
    const productWrap = review.querySelector('.stamped-review-product');
    if (
      productWrap &&
      material &&
      !productWrap.querySelector('.material-item-review')
    ) {
      productWrap.insertAdjacentHTML(
        'beforeend',
        `<div class="material-item-review">${material}</div>`
      );
    }
  });

  // stop interval after reviews processed
  if (el.querySelector('.stamped-review')) {
    clearInterval(checkStamped);
  }
}, 300);


function applyShadowStyle() {
  const host = document.querySelector('shopify-payment-terms');

  if (host && host.shadowRoot) {
    const style = document.createElement('style');
    style.textContent = `
      @media screen and (max-width: 440px) {
        #shopify-installments {
          margin-top: 10px;
          line-height: 1;
        }
      }
    `;

    host.shadowRoot.appendChild(style);
    return true;
  }

  return false;
}

const observer = new MutationObserver(() => {
  if (applyShadowStyle()) {
    observer.disconnect(); 
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

function updateStickyHeaderTop() {
  const announcementBar = document.querySelector('.mount-announcement-bar');
  const stickyHeader = document.querySelector('.mount-header.is-sticky');

  if (!stickyHeader) return;

  const barHeight = announcementBar
    ? announcementBar.offsetHeight
    : 0;

	// console.log(stickyHeader,'stickyHeader',barHeight);
  stickyHeader.style.top = `${barHeight}px`;
}
updateStickyHeaderTop();
window.addEventListener('resize', updateStickyHeaderTop);


// us timezone change price
document.addEventListener('DOMContentLoaded', () => {
  const wrappers = document.querySelectorAll('.js-discount-wrapper');

  wrappers.forEach((wrapper) => {
    const startDate = wrapper.dataset.startDate;
    const endDate = wrapper.dataset.endDate;

    if (!startDate) return;

    const pacificNow = new Date(
      new Date().toLocaleString('en-US', {
        timeZone: 'America/Los_Angeles'
      })
    );

    const start = new Date(startDate + 'T00:00:00');
    const end = endDate ? new Date(endDate + 'T23:59:59') : null;

    const discountBlock = wrapper.querySelector('.discount-price-block');
    const normalBlock = wrapper.querySelector('.normal-price-block');

    console.log(pacificNow,'pacificNow',start);

    const showDiscount = end
      ? pacificNow >= start && pacificNow < end
      : pacificNow >= start;

    if (showDiscount) {
      discountBlock.style.display = 'flex';
      normalBlock.style.display = 'none';
    } else {
      discountBlock.style.display = 'none';
      normalBlock.style.display = 'flex';
    }
  });
});